var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEllipseProductsGreenLeftPromocodeSection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1068,
    height: 1631,
    viewBox: "0 0 1068 1631",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_39_1546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.021 1301.23C81.1095 1213.45 -207.729 446.08 -21.4518 318.935C164.825 191.79 142.269 770.111 202.181 857.887C262.093 945.662 920.671 1011.82 734.394 1138.97C548.117 1266.11 200.933 1389 141.021 1301.23Z",
    fill: "url(#paint0_radial_39_1546)",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_39_1546",
    x: -383.208,
    y: 0.754395,
    width: 1450.68,
    height: 1630.13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_39_1546"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_39_1546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(230.695 1249.8) rotate(-105.951) scale(1327.8 2950.56)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37D881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37D881",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseProductsGreenLeftPromocodeSection);
export default __webpack_public_path__ + "static/media/Ellipse-products-green-left-promocode-section.ac6600adf4f39735c93cc76fcafce548.svg";
export { ForwardRef as ReactComponent };